import React from 'react'
import { connect } from 'react-redux'
import Email from '../../../../../lib/api/email'
import BackArrow from '../../../../../asset/Arrow-Left_Med.svg'

class SendInvite extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      email: '',
      status: null,
      validEmail: false,
      error: false
    }
  }

  onChange(e) {
    this.setState({ email: e.target.value, validEmail: e.target.validity.valid, error: false })
  }

  sendEmail() {
    const domain = process.env.NODE_ENV === 'production' && process.env.__NOTIFICATION_ENV__ == 'production' ? 'app.basemap.com' : 'staging.basemap.com'

    const to = this.state.email;
    const subject = 'BaseMap Invitation';
    const body = `Hello,

          I've invited you to join me on BaseMap! To get started, please register and download the BaseMap app using the links below:

          Download the BaseMap App: https://${domain}/

      Once you've registered and installed the app, you’ll be ready to explore maps together!

      Thank you
    `;

    // Create a mailto URL
    const mailtoURL = `mailto:${to}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

    // Open the default email client with the predefined details
    window.location.href = mailtoURL;
  };

  submitEmail() {
    this.sendEmail()
  }

  closeSendInvite = () => {
    this.props.closeSendInvite()
  }

  render() {
    const { email, status, error } = this.state
    return (
      <>
        <div className='sendinvite-close-icons'>
          <img className='sub-close-icon' src={BackArrow} onClick={() => { this.closeSendInvite() }} />
          <span className="left-expanded-header" style={{ marginTop: 10, marginRight: 10 }}>Send Invite</span>
        </div>

        <div className='group-sub-friends-search-container'>
          <div style={{ width: '80%', display: 'flex', flexDirection: 'column', position: 'relative', top: '5vh', }}>
            <div style={{ position: 'relative', width: '80%' }}>
              <input
                type="email"
                className="group-sub-find-user-input "
                style={{}} // extra padding so text doesn't overlap icon
                value={email}
                placeholder="Email"
                onChange={this.onChange.bind(this)}
              />
              <i
                className="material-icons"
                style={{
                  fontSize: '18px',
                  position: 'absolute',
                  right: '-13%',
                  top: '20%',
                  pointerEvents: 'none', // so clicks go to the input
                  color: '#999'
                }}
              >
                email
              </i>
            </div>
            <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <button onClick={this.submitEmail.bind(this)} style={{ width: '50%' }}>Send Email</button>
            </div>

          </div>
          {
            error !== false ?
              (<div>
                <p style={{ width: '100%', color: 'red', textAlign: 'center' }}>{error}</p>
              </div>) : null
          }
          {
            error === false && status !== null ?
              (<div>
                <p style={{ width: '100%', color: 'green', textAlign: 'center' }}>{status}</p>
              </div>) : null
          }
        </div>
      </>
    )
  }
}

const mapStateToProps = state => ({
  auth: state.auth
})

const mapDispatchToProps = dispatch => ({
})

export default connect(mapStateToProps, mapDispatchToProps)(SendInvite)